import { render, staticRenderFns } from "./FactorBaseRevealNetwork.vue?vue&type=template&id=2f84267e&scoped=true"
import script from "./FactorBaseRevealNetwork.vue?vue&type=script&lang=js"
export * from "./FactorBaseRevealNetwork.vue?vue&type=script&lang=js"
import style0 from "./FactorBaseRevealNetwork.vue?vue&type=style&index=0&id=2f84267e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f84267e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f84267e')) {
      api.createRecord('2f84267e', component.options)
    } else {
      api.reload('2f84267e', component.options)
    }
    module.hot.accept("./FactorBaseRevealNetwork.vue?vue&type=template&id=2f84267e&scoped=true", function () {
      api.rerender('2f84267e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/FactorBaseRevealNetwork.vue"
export default component.exports